
import React from 'react';
import { BadgePercent, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TeamPricing: React.FC = () => {
  return (
    <div className="mt-16 text-center p-8 md:p-10 bg-gradient-to-r from-yellow-300 via-beige to-yellow-300 rounded-3xl shadow-md border border-yellow-500 max-w-5xl mx-auto transition-all duration-300 hover:shadow-lg relative overflow-hidden">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="text-left max-w-md">
          <h3 className="text-3xl font-montserrat font-bold mb-3 text-darkgray">Anbudsteam-lösning</h3>
          <p className="text-darkgray/70 text-lg font-opensans">
            Behöver du en anpassad lösning för ditt anbudsteam? Vi erbjuder volymrabatter för team med fler än 5 användare.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center gap-5">
          <div className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-yellow-300/70">
            <div className="bg-yellow-300 p-2 rounded-full">
              <BadgePercent className="h-6 w-6 text-darkgray" />
            </div>
            <div>
              <p className="font-bold text-xl text-darkgray font-montserrat">Upp till 30% rabatt</p>
              <p className="text-sm text-darkgray/70 font-opensans">för större anbudsteam</p>
            </div>
          </div>
          
          <Button 
            className="w-full sm:w-auto bg-darkgray hover:bg-black text-white font-montserrat font-bold transition-all duration-300 px-8 py-6 rounded-xl"
          >
            <Users className="mr-2 h-5 w-5" />
            Kontakta oss
          </Button>
        </div>
      </div>
      
      <div className="absolute -top-12 -left-12 w-24 h-24 rounded-full bg-yellow-300/50 z-0"></div>
      <div className="absolute -bottom-16 -right-16 w-32 h-32 rounded-full bg-yellow-500/20 z-0"></div>
      <div className="absolute top-1/2 left-1/4 w-8 h-8 rounded-full bg-yellow-500/10 z-0"></div>
    </div>
  );
};

export default TeamPricing;
